import {createFileRoute} from '@tanstack/react-router'
import AssessmentsList from "../../../../components/assessments/AssessmentsList.tsx";
import Header from "../../../../Header.tsx";

export const Route = createFileRoute('/_app/organizer/assessments/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />

        <div className={"max-w-6xl w-11/12 mx-auto"}>
            <AssessmentsList viewed_as_club={true} />
        </div>
    </>
}
